import jQuery from 'jquery';
import _ from 'lodash';
import Rx from 'ub_wrapped/rx';

import {
  DTR_TAG_CLASS,
  DTR_TAG_BORDER_PADDING,
  DTR_TAG_BORDER_OFFSET,
  REMOVE_BUTTON_CLASS,
  REMOVE_BUTTON_MIN_HEIGHT
} from 'ub/ui/inline-text/dynamic-text-defaults';

export default class RemoveDTRButton {
  constructor(onRemove) {
    this.onRemove = onRemove;
  }

  _buildRemoveDtrButton () {
    const removeDtrButton = document.createElement('div');
    removeDtrButton.className = REMOVE_BUTTON_CLASS;

    Rx.Observable.fromEvent(removeDtrButton, 'mouseout').subscribe(this.safeHide.bind(this));
    Rx.Observable.fromEvent(removeDtrButton, 'mouseover').subscribe(this._resetRemoveDTRButtonTimer.bind(this));
    Rx.Observable.fromEvent(removeDtrButton, 'click')
      .subscribe(() => {
        this.hide();
        this.onRemove();
      });

    return removeDtrButton;
  }

  _calculateNewBounds (lastRect, parentOffset) {
    // The offset provided by clientRects is relative to the document, so we need to subtract the parents
    // document offset to get the relative offset of the remove button
    const relativeBounds = {
      top: lastRect.top - parentOffset.top,
      left: lastRect.width + lastRect.left - parentOffset.left,
      height: lastRect.height > REMOVE_BUTTON_MIN_HEIGHT ? lastRect.height : REMOVE_BUTTON_MIN_HEIGHT
    };

    return {
      top: relativeBounds.top - DTR_TAG_BORDER_PADDING + 'px',
      left: relativeBounds.left + 'px',
      height: relativeBounds.height + DTR_TAG_BORDER_PADDING + DTR_TAG_BORDER_OFFSET + 'px'
    };
  }

  _resetRemoveDTRButtonTimer () {
    clearTimeout(this._timer);
  }

  reposition (currentDtrTarget) {
    this._resetRemoveDTRButtonTimer();

    this.currentDtrTarget = currentDtrTarget;
    this._buttonElement = this._buttonElement || this._buildRemoveDtrButton(this.currentDtrTarget);
    this._buttonElement.style.display = 'flex';

    jQuery(this.currentDtrTarget).closest('.lp-element.lp-pom-text').append(this._buttonElement);

    const dtrClientRects = this.currentDtrTarget.getClientRects();
    const lastRect = _.last(dtrClientRects);
    const parentOffset = jQuery(this.currentDtrTarget).closest('.text-content').offset();
    const newBounds = this._calculateNewBounds(lastRect, parentOffset);

    Object.assign(this._buttonElement.style, newBounds);
  }

  safeHide (newTargetClassName) {
    // Check to see you've moused away from both the tag and the x button
    if (newTargetClassName !== REMOVE_BUTTON_CLASS && newTargetClassName !== DTR_TAG_CLASS) {

      // Close button easy to overshoot without delay timer
      this._timer = setTimeout(this.hide.bind(this), 750);
    }
  }

  hide () {
    this._buttonElement.style.display = 'none';
  }
}



// WEBPACK FOOTER //
// ./src/ui/inline-text/remove-dtr-button.js